import { Client } from '@api/index'
import { Loader } from '@pw-tech/omni-ui'
import { Base64 } from '@utils/encode-utilities'
import { ApplicationTypes } from '@utils/enum'
import { useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

const OrderSummary = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const [url, setUrl] = useState('') // Sample URL
  const [isLoaded, setIsLoaded] = useState(true)
  const [searchParams] = useSearchParams()
  const info = searchParams.get('info') || ''
  const planId = searchParams.get('planId') || ''

  const checkLoaded = (event: React.SyntheticEvent<HTMLIFrameElement>) => {
    setIsLoaded(false)
    sendData(iframeRef.current)
  }

  const sendData = (iframe: HTMLIFrameElement | null) => {
    const planDetails = JSON.parse(localStorage.getItem('PLAN_DETAILS') || '{}')
    setTimeout(() => {
      const data: any = {
        applicationType: ApplicationTypes.BATCH_PLUS_TABLE,
        redirectionType: 'BUY_NOW',
      }
      if (planDetails) {
        data.selectedPlan = planDetails?._id
      }
      iframe?.contentWindow?.postMessage(data, '*')
    }, 500)
  }

  const getPlanDetails = async (id: string) => {
    const userId = JSON.parse(localStorage.getItem('user') || '{}')?.id || ''
    try {
      if (typeof window !== 'undefined') {
        const response: any = await Client.get(
          `${process.env.REACT_APP_PP_API_BASE_URL}/v1/student-acquisition/ambassador-client/${id}/plans/${userId}`
        )
        return response?.data?.data
      }
    } catch (err: any) {}
  }

  const updatePaymentUrl = async () => {
    const batchDetails: any = JSON.parse(
      localStorage.getItem('BATCH_DETAILS') || '{}'
    )
    const infoObject = JSON.parse(Base64.decode(info) || '{}')
    const batchId = infoObject?.batchSlug || batchDetails?._id || ''

    const isPowerBatch = batchDetails?.masterBatchId
    const isVPOfflineWithEzPayEnabled =
      (batchDetails?.isPathshala || batchDetails?.config?.isVidyapeeth) &&
      (batchDetails?.config?.isEZPayEnabled || batchDetails?.isEZPayEnabled)

    if (isPowerBatch) {
      const partPayment = await getPlanDetails(batchId)
      const isPowerBatchWithEzPayEnabled =
        partPayment?.plans?.length && partPayment?.plans[0]?.isEZPayEnabled
      if (isPowerBatchWithEzPayEnabled) {
        setUrlForIframe(process.env.REACT_APP_PAYMENT_MF_LINK || '')
        return
      }
    }
    if (isVPOfflineWithEzPayEnabled) {
      setUrlForIframe(process.env.REACT_APP_PAYMENT_MF_LINK || '')
      return
    }

    setUrlForIframe(process.env.REACT_APP_FBT_PAYMENT_LINK || '')
  }

  const setUrlForIframe = (url: string) => {
    if (!url) return
    const token =
      localStorage.getItem('token') || localStorage.getItem('TOKEN') || ''
    const randomId =
      localStorage.getItem('uuid') ?? localStorage.getItem('randomId')
    const batchBuyUserId = localStorage.getItem('BATCH_BUY_USER_ID') || ''
    const coupanData = JSON.parse(localStorage.getItem('couponData') || '{}')
    const batchUserPhoneNumber = localStorage.getItem('BUY_PHONE_NUMBER') || ''
    const userName = localStorage.getItem('BUY_USER_NAME') || ''
    const redirectRoute =
      url === process.env.REACT_APP_PAYMENT_MF_LINK ? 'payment' : 'authenticate'
    let localUrl =
      url +
      `/${redirectRoute}?token=${token}&random_id=${randomId}&client_type=WEB&CONFIG=${info}&redirectUrl=${`/`}&cameFrom=ambassador&batchBuyUserId=${batchBuyUserId}&batchUserPhoneNumber=${batchUserPhoneNumber}&userName=${userName}`
    if (planId) {
      localUrl += `&planId=${planId}`
    }
    if (coupanData?.couponCode) {
      localUrl += `&coupanCode=${coupanData?.couponCode}`
    }
    setUrl(localUrl)
  }

  const paymentGatewayScriptForSkills = (infoObject: any) => {
    const token =
      localStorage.getItem('token') || localStorage.getItem('TOKEN') || ''
    const randomId =
      localStorage.getItem('uuid') ?? localStorage.getItem('randomId')
    const batchBuyUserId = localStorage.getItem('BATCH_BUY_USER_ID') || ''
    const coupanData = JSON.parse(localStorage.getItem('couponData') || '{}')
    const batchUserPhoneNumber = localStorage.getItem('BUY_PHONE_NUMBER') || ''
    const cohortId = localStorage.getItem('COHORT_ID') || ''
    const selectedPlan = infoObject?.courseId
    const redirectionUrl = `https://ambassador.pw.live/sales/batch-listing?cohortId=${cohortId}`
    const params = new URLSearchParams({
      token,
      from: 'ambassador',
      randomId: randomId || '',
      batchBuyUserId,
      couponCode: coupanData?.couponCode || '',
      to: `/checkout?course_id=${selectedPlan}`,
      userPhoneNumber: batchUserPhoneNumber,
      returnUrl: redirectionUrl,
    })

    setUrl(`https://pwskills.com?${params.toString()}`)
  }

  useEffect(() => {
    // Optional: perform something when URL changes`
    const infoObject = JSON.parse(Base64.decode(info) || '{}')
    if (infoObject?.cameFrom === 'skills') {
      paymentGatewayScriptForSkills(infoObject)
    } else {
      updatePaymentUrl()
    }
  }, [info])

  return (
    <div>
      {isLoaded && (
        <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
          <Loader size="medium" />
        </div>
      )}

      <iframe
        allow="clipboard-read; clipboard-write; accelerometer; autoplay; fullscreen; encrypted-media; gyroscope; picture-in-picture"
        ref={iframeRef}
        className="responsive-iframe h-full"
        id="spdIframe"
        src={url}
        onLoad={checkLoaded}
        title="SPD Iframe"
        style={{ width: '100%', height: '100vh', border: 'none' }}
      ></iframe>
    </div>
  )
}

export default OrderSummary
